import React, { useState } from "react";
import "./SavestFlexible.css";
import { Formik, Form } from "formik";
import { BankTranferDetailsTextInput } from "../../../../../../Formik/BankDetailsInput";
import * as Yup from "yup";
import { Util } from "../../../../../../../../helpers/util";

const CreateFlexible = ({ setMenu }) => {
  const [fields, setFields] = useState({
    amount_to_save: "",
    target_amount: "",
    automation_status: 0,
    earn_interest: false,
    saving_type: "flexible",
    payment_method: "ovest_wallet",
    automatic_payment_method: "ovest_wallet",
  });
  const { currency } = Util.getCurrency();

  const handleNextClick = () => {
    Util.set("create_flexible_plan", fields);

    setMenu(2);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFields({ ...fields, [name]: value });
  };

  const handleCheckClick = () => {
    setFields({ ...fields, earn_interest: !fields.earn_interest });
  };
  return (
    <div className="create-flexible-plan">
      <div className="create-flexible-plan-main">
        <div className="create-flexible-header">
          <h5 className="create-flexible-h5">Create Flexible Plan</h5>
          <p className="create-flexible-p">
            Save strictly for emergencies and earn up to 3.5% every 15 days.
          </p>
        </div>
        <div className="savest-amount-tosave">
          <p className="savest-amount-p">How much would you like to save ? </p>
          <Formik
            initialValues={{
              amount: "",
            }}
            onSubmit={(values, { setSubmittimg, setFieldError }) => {
              console.log(values);
            }}
            validationSchema={Yup.object({
              amount: Yup.string().required(
                "Amount deposited Field is required"
              ),
            })}
          >
            {({ isSubmitting }) => (
              <Form>
                <BankTranferDetailsTextInput
                  name="amount_to_save"
                  type="tel"
                  value={fields.amount_to_save}
                  onChange={handleInputChange}
                  placeholder={currency}
                />
              </Form>
            )}
          </Formik>
        </div>
        <div className="amount-targeted">
          <p className="savest-amount-p2 mt-5">What is your target amount?</p>
          <Formik
            initialValues={{
              amount: "",
            }}
            onSubmit={(values, { setSubmittimg, setFieldError }) => {
              console.log(values);
            }}
            validationSchema={Yup.object({
              amount: Yup.string().required(
                "Amount deposited Field is required"
              ),
            })}
          >
            {({ isSubmitting }) => (
              <Form>
                <BankTranferDetailsTextInput
                  name="target_amount"
                  value={fields.target_amount}
                  onChange={handleInputChange}
                  type="tel"
                  placeholder={currency}
                />
              </Form>
            )}
          </Formik>
        </div>
        <div className="checkbox-automate">
          <p className="savest-amount-p">
            Do you wish to automate your savings?
          </p>
          <input
            type="radio"
            id="html"
            name="automation_status"
            onChange={handleInputChange}
            value={0}
            className=" mt-3"
          />

          <label htmlFor="" className="savest-plan-label">
            Yes, I will like to be debited automatically
          </label>
          <br />
          <input
            type="radio"
            id="html"
            name="automation_status"
            onChange={handleInputChange}
            value={1}
            className=" mt-4"
          />
          <label htmlFor="" className="savest-plan-label">
            No, I will like to save whenever I want
          </label>
        </div>
        <button onClick={handleNextClick} className="savest-button">
          Next
        </button>

        <div className="checkbox-main">
          <input
            type="checkbox"
            id=""
            className="checkbox-input"
            name="earn_interest"
            onChange={handleCheckClick}
            checked={fields.earn_interest}
          />
          <label htmlFor="" className="earninterest-savest">
            Earn interest on this saving plan
          </label>
        </div>
      </div>
    </div>
  );
};

export default CreateFlexible;
